import {FormattedMessage} from "react-intl";
import './GeoRestrictedView.style.scss';

const GeoRestrictedView = () => {
    return (
        <div className="GeoRestrictedView">
            <div></div>
            <h1><FormattedMessage id="geoRestrictedView.title" /></h1>
            <p><FormattedMessage id="geoRestrictedView.subTitle"/></p>
            <div></div>
        </div>
    );
}
export default GeoRestrictedView;